import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { ColumnWidthInfo } from "../../../common/services/crudServices";
import { useRootStore } from "../../../../store/contexts";
import { ShowNumber } from "../../../common/controls";
import { ShowReference } from "../../../common/controls";
import { ShowItemsCompact } from "../../../common/controls";
import { CrudRows } from "../../../common/types";
import { GridColumn } from "../../../common/types";
import { FormControl } from "@mui/material";

export type CreditAccountViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  balanceValue?: { displayId: string; id: string } | null;
  balance: number;
  tierValue: { displayId: string; id: string } | null;
  movementsRows: CrudRows;
  movementsVisibleColumns: GridColumn[];
  movementsSetColumnWiths: (x: ColumnWidthInfo[]) => void;
};

export const CreditAccountViewForm: React.FC<CreditAccountViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      balance = 0,
      tierValue,
      movementsRows,
      movementsVisibleColumns,
      movementsSetColumnWiths,
    }) => {
      const rootStore = useRootStore();
      const { authStore, langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupCreditAccountLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowNumber
                  value={balance}
                  label={langStore.CreditAccountBalanceLabel}
                />
                {["SysAdmin"].some((role) => authStore.hasRole(role)) && (
                  <ShowReference
                    label={langStore.CreditAccountTierLabel}
                    selectedValue={langStore.displayIdByLang(
                      tierValue?.displayId
                    )}
                  />
                )}
                <ShowItemsCompact
                  rows={movementsRows}
                  showLabel={true}
                  label={langStore.CreditAccountMovementsLabel}
                  columns={movementsVisibleColumns}
                  setColumnWidths={movementsSetColumnWiths}
                  entityName="CreditMovement"
                  enableDownload={true}
                  onRowClick={(rowId) =>
                    rootStore.openSubentityModal("creditMovement", rowId)
                  }
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
